import React, { useEffect, useState } from 'react'

// need @tailwindcss/forms for styled checkbox

const Checkbox = ({
    checked = false,
    onChange = (checked, data) => { },
    confirmChange = (checked, data) => { return true },
    data = {},
}) => {

    const handleChange = (e) => {
        const newChecked = e.target.checked;
        console.log("[handleChange]", newChecked);
        const ok = confirmChange(newChecked, data);
        if (!ok) {
            return;
        }
        onChange(newChecked, data)
    }

    return (
        <div className="flex justify-center items-center">
            <input
                id="candidates"
                aria-describedby="candidates-description"
                name="candidates"
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                checked={checked}
                onChange={handleChange}
                readOnly={true}
            ></input>
        </div>
    )
}

export default Checkbox;
